import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import MainLayout from '../../../components/Layout/MainLayout';
import { BackIcon } from '../../../components/Dashboard/DataCenterIcons';
import '../../../assets/styles/RSCUploadPage.css';

const RSCUploadPage: React.FC = () => {
  const navigate = useNavigate();
  const [file, setFile] = useState<File | null>(null);

  const onFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const f = e.target.files && e.target.files[0] ? e.target.files[0] : null;
    setFile(f);
  };

  const onUpload = () => {
    if (!file) return;
    // TODO: integrate upload API
    console.log('Uploading file:', file.name);
  };

  return (
    <MainLayout>
      <div className="rsc-upload-page">
        <div className="rsc-upload-header">
          <div className="header-left">
            <button onClick={() => navigate('/data-centers/vdc')} className="regular-rdc-back-button">
              <BackIcon />
              Back
            </button>
            <span className="rsc-upload-subtitle">RSC upload</span>
          </div>
          <a className="rsc-upload-template-link" href="#">Download Template</a>
        </div>

        <div className="rsc-upload-card">
          <label className="file-label">Choose File</label>
          <input className="file-input" type="file" onChange={onFileChange} />
          <button className="upload-button" onClick={onUpload} disabled={!file}>Upload</button>
        </div>

        <div className="rsc-upload-status">
          <button className="status-button">Status of uploaded data</button>
        </div>
      </div>
    </MainLayout>
  );
};

export default RSCUploadPage;
